function getKey(key: string) {
  return key === "_default" ? "" : key
}

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function generateVars<T extends Record<string, any>>(colorObject: T) {
  let result = '';

  function traverseObject(obj: T, globalPrefix: string, prefix = '',) {
    for (const key in obj) {

      const value = obj[key];
      const prop = getKey(prefix) + capitalizeFirstLetter(getKey(key));

      if (typeof value === 'object') {
        traverseObject(value, globalPrefix, prop);
      } else {
        result += `--${globalPrefix}${prop}: ${value};`; // \n
      }
    }
  }

  for (const key in colorObject) {
    const value = colorObject[key];

    if (typeof value === 'object') {
      traverseObject(value, key);
    } else {
      result += `--${key}: ${value};` // \n
    }
  }

  return result;
}

